<template>
  <div>
    <div v-if="user.key">
      <div v-if="(isPrincipal || isManager) && isPremier">
        <div v-if="isDeviceVerified || isValidOAUser()">
          <div class="page-header">
            <div v-show="bannerOpen">
              <banner
                :href="virtualToursLpUrl"
                @close="closeBanner()"
                :galabel="`AID=${agent.id}`"
              ></banner>
            </div>
            <div class="ut-container-lg ut-relative">
              <h2
                class="
                  ut-text-3xl ut-font-bold ut-pb-3
                  md:ut-pb-8
                  ut-pt-4
                  md:ut-pt-16
                "
              >
                Leads
              </h2>
              <lead-search class="lead-search" v-if="displayLeadSearch" gacategory="Leads"/>
            </div>
          </div>
          <premier-leads-list
              :uk="user.key"
              :ak="ak"
            />
        </div>
        <user-device-verification v-else>
          <template v-slot:header>
            <div class="page-header">
              <div v-show="bannerOpen">
                <banner
                  :href="virtualToursLpUrl"
                  @close="closeBanner()"
                  :galabel="`AID=${agent.id}`"
                ></banner>
              </div>
              <div class="ut-container-lg ut-relative">
                <h2
                  class="
                    ut-text-3xl ut-font-bold ut-pb-3
                    md:ut-pb-8
                    ut-pt-4
                    md:ut-pt-16
                  "
                >
                  Leads
                </h2>
              </div>
            </div>
          </template>
        </user-device-verification>
      </div>
      <div v-else>
        <div class="page-header">
          <div v-show="bannerOpen">
            <banner
              :href="virtualToursLpUrl"
              @close="closeBanner()"
              :galabel="`AID=${agent.id}`"
            ></banner>
          </div>
          <div class="ut-container-lg ut-relative">
            <h2
              class="
                ut-text-3xl ut-font-bold ut-pb-3
                md:ut-pb-8
                ut-pt-4
                md:ut-pt-16
              "
            >
              Leads
            </h2>
            <lead-search class="lead-search" v-if="displayLeadSearch" gacategory="Leads"/>
          </div>
        </div>
        <none-premier-leads-list :ak="ak" :leadsFetched="leadsFetched"/>
      </div>
    </div>
    <loading-spinner v-else />
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import PremierLeadsList from "@/components/LeadsList/PremierLeadsList.vue";
import NonePremierLeadsList from "@/components/LeadsList/NonePremierLeadsList.vue";
import LoadingSpinner from "@/components/Animations/LoadingSpinner.vue";
import LeadSearch from "@/components/LeadSearch.vue";
import Banner from "@/components/Banner.vue";
import UserDeviceVerification from "@/components/UserDeviceVerification.vue";
import cookieHelpers from "@/helpers/cookie-helpers";

export default {
  name: "leads",
  components: {
    PremierLeadsList,
    NonePremierLeadsList,
    LoadingSpinner,
    LeadSearch,
    Banner,
    UserDeviceVerification,
  },
  props: {
    ak: String,
  },
  data() {
    return {
      leadsFetched: false,
      // userLoaded: false,
    };
  },
  created() {
    // We currently cannot use that service to get lead agent mappings whith no agent key
    if (
      (!this.lams || this.lams.length === 0) &&
      !!this.ak &&
      this.ak.length > 0
    ) {
      this.getLams();
    } else {
      this.leadsFetched = true; // i.e data was already fetched
    }
  },
  computed: {
    ...mapGetters("userStore", [
      "isPremier",
      "isPrincipal",
      "isManager",
      "isDeviceVerified",
    ]),
    ...mapGetters("bannerStore", ["bannerOpen"]),
    ...mapState({
      user: (state) => state.userStore.user,
      lams: (state) => state.leadsListStore.leadsList,
      allLeadsListForPrincipal: (state) =>
        state.principalStore.allLeadsListForPrincipal,
      agent: (state) => state.agentStore.agent,
    }),
    displayLeadSearch() {
      return (
        (this.ak && this.ak.length > 0 && this.lams && this.lams.length > 0) ||
        (this.allLeadsListForPrincipal &&
          this.allLeadsListForPrincipal.length > 0)
      );
    },
    virtualToursLpUrl() {
      return `${process.env.VUE_APP_OA_VIRTUAL_TOURS_LP}?ak=${this.agent.key}`;
    },
  },
  mounted() {
    // this.$store.subscribe((mutation) => {
    //   switch (mutation.type) {
    //     case 'userStore/setUser':
    //       this.userLoaded = true;
    //       break;
    //     default:
    //       break;
    //   }
    // });
  },
  methods: {
    ...mapActions("leadsListStore", ["loadLeadsList"]),
    ...mapActions("bannerStore", ["changeState"]),
    getLams() {
      const payload = { agentKey: this.ak };
      this.loadLeadsList(payload).then(() => {
        this.leadsFetched = true;
      });
    },
    closeBanner() {
      this.changeState(false);
    },
    isValidOAUser() {
      return cookieHelpers.verifyValidOAUser();
    },
  },
};
</script>

<style scoped lang="scss">
.table-head {
  border: 1px solid #e3e5e8;
  div {
    @apply ut-text-xs ut-tracking-wide opacity-75;
    opacity: 0.69;
  }
}

.lead-search {
  @apply ut-absolute ut-mr-4 ut-right-0;
  top: 50%;
  transform: translateY(-50%);
  width: 400px;
  max-width: 50%;

  @screen md {
    transform: unset;
  }
}
</style>
